<template>
  <div>
    <Modal v-model="isTemplate" scrollable footer-hide closable title="手机验证码登录" :z-index="1" @on-cancel="cancel" width="450px">

      <div class="article-manager">
        <Card :bordered="false" dis-hover class="ivu-mt">

          <Form ref="formItem" :model="formItem" :rules="ruleValidate" @submit.native.prevent>

            <Row type="flex" :gutter="24">
              <Col span="24">
                <Col v-bind="grid">
                  <FormItem label-for="phone">
					<Input type="text" v-model="formItem.phone" prefix="ios-contact-outline" placeholder="请输入用户名" size="large" />
                  </FormItem>
                </Col>
              </Col>
              <Col span="24">
                <Col v-bind="grid">
                  <FormItem label-for="code">
					  <div style=" display: flex;align-items: center;justify-content: center;">
						<Input type="text" v-model="formItem.code" prefix="ios-keypad-outline" placeholder="请输入验证码" size="large" />
						<Button style="margin-left: 20px;" :disabled="disabled" :class="disabled === true ? 'on' : ''" type="primary" @click="getCode">{{text}}</Button>
					  </div>
					
                  </FormItem>
                </Col>
              </Col>
			  <Col span="24" style="text-align: center;">
			     <Button size="large" type="primary" long @click="handleSubmit('formItem')">登录</Button>
				 <p>注册请前往APP或者小程序端口</p>
			  </Col>
            </Row>
			
          </Form>

        </Card>

      </div>
    </Modal>
  </div>
</template>

<script>
import sendVerifyCode from "@/mixins/SendVerifyCode";
import { verifyCode, login } from "@/api"
import { setCookies } from "@/libs/util";
export default {
	name:'login',
	inject: ['reload'],
	mixins: [sendVerifyCode],
  data() {
    return {
      isTemplate: false,
      formItem: {
        phone: "",
        code: '',
      },
      ruleValidate: {
        name: [ { required: true, message: "请输入商家名称", trigger: "blur" }],
      },
      grid: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
    };
  },
  methods: {
	  
	  // 获取板块分类列表
	  async getCode() {
		  	let that = this;
		  	if (!this.formItem.phone) {
				alert('请填写手机号码')
				return 
			}
		  	if (!/^1(3|4|5|7|8|9|6)\d{9}$/i.test(this.formItem.phone)) {
				alert('请输入正确的手机号码')
				return 
			}
		  	await verifyCode({
				phone: this.formItem.phone
			})
			.then(res => {
				this.$Message.success('验证码已发送');
				that.sendCode();
			})
			.catch(res => {
				this.$Message.error(res.msg);
			});
	  },

    cancel() {
      this.$refs["formItem"].resetFields();
      this.clearFrom();
    },

    clearFrom() {
      this.formItem.phone = "";
      this.formItem.code = "";
    },
	
	getExpiresTime(expiresTime) {
	  let nowTimeNum = Math.round(new Date() / 1000);
	  let expiresTimeNum = expiresTime - nowTimeNum;
	  return parseFloat(parseFloat(parseFloat(expiresTimeNum / 60) / 60) / 24);
	},

    // 提交
    handleSubmit(name) {
		let that = this
		if (!this.formItem.phone) {
			alert('请填写手机号码')
			return 
		}
		if (!/^1(3|4|5|7|8|9|6)\d{9}$/i.test(this.formItem.phone)) {
			alert('请输入正确的手机号码')
			return 
		}
		if(!this.formItem.code) {
			alert('请输入验证码')
			return 
		}
      this.$refs[name].validate((valid) => {
        if (valid) {
          login(that.formItem)
            .then(async (res) => {
				let data = res.data
				let expires = that.getExpiresTime(data.exp_time);
				setCookies("webtoken", data.token, expires);
				setCookies("webexpires_time", data.exp_time, expires);
				
				that.$store.commit('UPDATE_USERINFO', data.userInfo);
				that.$Message.success(res.msg);
				that.isTemplate = false;
				that.$refs[name].resetFields();
				that.clearFrom();
				that.reload()
            })
            .catch((res) => {
				console.log(res)
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped >
.picBox {
  display: inline-block;
  cursor: pointer;
}

.mapBox >>> .ivu-modal-body {
  height: 640px !important;
}

.btn {
  margin: 0 auto;
  width: 40%;
}

.pictrueBox {
  display: inline-block;
}

.pictrueTab {
  width: 40px !important;
  height: 40px !important;
}
</style>
